import React from "react";
import _ from "lodash";
import Responsive from "react-responsive";

import styled, { keyframes } from "styled-components";

import { texts, CNtexts, RUtexts } from "./common";
import Button from "../../components/Button";
import ButtonGroup from "../../components/ButtonGroup";
import Pin from "../../components/svg/Pin";
import MultiLineText from "../../components/svg/MultiLineText";
import Airplane from "../../components/svg/Airplane";
import LagunaPropertyBubble from "../../components/svg/LagunaPropertyBubble";

const contentPath = process.env.REACT_APP_CLOUDFRONT;

const iconAirport = `${contentPath}/assets/images/phuket-map/map-icon-01.png`;
const iconBeach = `${contentPath}/assets/images/phuket-map/map-icon-02.png`;
const iconIsland = `${contentPath}/assets/images/phuket-map/map-icon-03.png`;
const iconSchool = `${contentPath}/assets/images/phuket-map/map-icon-05.png`;
const iconAttraction = `${contentPath}/assets/images/phuket-map/map-icon-06.png`;

const bg = `${contentPath}/assets/images/phuket-map/phuket-map.png`;

const Desktop = (props) => <Responsive {...props} minWidth={768} />;
const Mobile = (props) => <Responsive {...props} maxWidth={767} />;

const overwriteMerge = (destinationArray, sourceArray, options) => {
  const destination = destinationArray.slice();

  sourceArray.forEach((e, i) => {
    Object.keys(e).forEach((key) => {
      // console.log(destination[0][key])
      destination[i][key] = sourceArray[i][key];
    });
  });

  return destination;
};

const switchLanguage = (activeLanguage) => {
  switch (activeLanguage) {
    case "cn":
      return CNtexts;
    case "ru":
      return RUtexts;
    default:
      return texts;
  }
};

const INITIAL_STATE = {
  currentPage: "airport",
};

const bounce = keyframes`
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.05);
  }
`;

const AnimatedBubble = styled.g`
  transform-origin: 50% 50%;
  animation: ${bounce} 1s infinite ease-out alternate;
`;

// Render Bubble in Pin
const renderPinBubble = (
  { text, textAnchor = "start", width, style },
  { currentLanguage }
) => {
  return (
    <g>
      {typeof text[currentLanguage] === "string" && (
        <text
          x={0}
          y={0}
          width={width}
          height={28}
          textAnchor={textAnchor}
          style={{ fill: "#454969", fontSize: 10, ...style }}
        >
          {text[currentLanguage]}
        </text>
      )}
      {_.isArray(text[currentLanguage]) && (
        <MultiLineText
          x={0}
          text={text[currentLanguage]}
          textAnchor="start"
          style={style}
        />
      )}
    </g>
  );
};

// Render Side Button
const renderButton = ({ value, label, icon, active, type, key, onClick }) => {
  return (
    <Button
      key={key}
      type="default"
      active={active}
      activeStyle={{ backgroundColor: "#ffffff", color: "black" }}
      hoverStyle={{ backgroundColor: "#ffffff", color: "black" }}
      defaultStyle={{
        marginRight: "3px",
        backgroundColor: "#dbdbdb",
        padding: "2px 5px 2px 5px",
        letterSpacing: 0,
        color: "black",
        marginBottom: "3px",
      }}
      onClick={onClick}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={icon}
          alt=""
          width={23}
          height={23}
          style={{ marginRight: 7 }}
        />
        {label}
      </div>
    </Button>
  );
};

class PhuketMap extends React.Component {
  static defaultProps = {
    texts: [
      // Terrain
      {
        type: "MultiLineText",
        group: "terrain",
        x: 318,
        y: 66,
        text: ["PHANG NGA"],
        style: { fill: "#606769" },
      },
      {
        type: "MultiLineText",
        group: "terrain",
        textAnchor: "start",
        x: 258,
        y: 329,
        text: ["THEPKASATTRI RD."],
        style: { fill: "#434a69" },
      },
      {
        type: "MultiLineText",
        group: "terrain",
        textAnchor: "end",
        x: 211,
        y: 424,
        text: ["BAN DON", "CHERNG", "TALAY RD."],
        style: { fill: "#434a69" },
      },
      {
        type: "MultiLineText",
        group: "terrain",
        textAnchor: "start",
        x: 192,
        y: 471,
        text: ["SRISOONTHORN RD."],
        style: { fill: "#434a69" },
      },
      {
        type: "MultiLineText",
        group: "terrain",
        textAnchor: "end",
        x: 171,
        y: 115,
        text: ["SARASIN BRIDGE"],
        style: { fill: "#41d3ab" },
      },
    ],
    pins: [
      // Airport
      {
        type: "Pin",
        color: "#58595b",
        group: "airport",
        animated: false,
        x: 237,
        y: 275,
        markerWidth: 10,
        renderPin: () => <Airplane x={-15} y={-20} width={20} height={20} />,
        bubble: {
          x: 10,
          y: -24,
          text: {
            en: ["PHUKET", "INTERNATIONAL", "AIRPORT"],
            cn: ["PHUKET", "INTERNATIONAL", "机场"],
            ru: ["PHUKET", "INTERNATIONAL", "Аэропорт"],
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#58595b" },
        },
      },

      // Beach
      {
        type: "Pin",
        color: "#454969",
        group: "beach",
        animated: false,
        x: 165,
        y: 427,
        markerWidth: 15,
        bubble: {
          x: -14,
          y: -10,
          text: {
            en: "BANGTAO BEACH",
            cn: "邦涛海滩",
            ru: "Пляж Банг Тао",
          },
          textAnchor: "end",
          render: renderPinBubble,
          style: { fontSize: 14 },
        },
      },
      {
        type: "Pin",
        color: "#454969",
        group: "beach",
        animated: false,
        x: 157,
        y: 448,
        markerWidth: 10,
        bubble: {
          x: -10,
          y: -10,
          text: {
            en: "SURIN BEACH",
            cn: "苏林海滩",
            ru: "Пляж Сурин (Surin Beach)",
          },
          textAnchor: "end",
          render: renderPinBubble,
        },
      },
      {
        type: "Pin",
        color: "#454969",
        group: "beach",
        animated: false,
        x: 156,
        y: 473,
        markerWidth: 10,
        bubble: {
          x: -10,
          y: -10,
          text: {
            en: "KAMALA BEACH",
            cn: "卡玛拉海滩",
            ru: "Пляж Камала (Kamala Beach)",
          },
          textAnchor: "end",
          render: renderPinBubble,
        },
      },
      {
        type: "Pin",
        color: "#454969",
        group: "beach",
        animated: false,
        x: 182,
        y: 542,
        markerWidth: 10,
        bubble: {
          x: -10,
          y: -10,
          text: {
            en: "PATONG BEACH",
            cn: "芭东海滩",
            ru: "Пляж Патонг (Patong Beach)",
          },
          textAnchor: "end",
          render: renderPinBubble,
        },
      },

      // Island
      {
        type: "Pin",
        color: "#728dae",
        group: "island",
        animated: false,
        x: 382,
        y: 441,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: "RANG NOI ISLAND",
            cn: "小朗岛",
            ru: "Остров Rang Noi",
          },
          textAnchor: "start",
          render: renderPinBubble,
        },
      },
      {
        type: "Pin",
        color: "#728dae",
        group: "island",
        animated: false,
        x: 382,
        y: 462,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: "RANG YAI ISLAND",
            cn: "大朗岛",
            ru: "Остров Rang Yai",
          },
          textAnchor: "start",
          render: renderPinBubble,
        },
      },
      {
        type: "Pin",
        color: "#728dae",
        group: "island",
        animated: false,
        x: 360,
        y: 488,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: "COCONUT ISLAND",
            cn: "椰子岛",
            ru: "Остров Coconut Island",
          },
          textAnchor: "start",
          render: renderPinBubble,
        },
      },
      {
        type: "Pin",
        color: "#728dae",
        group: "island",
        animated: false,
        x: 398,
        y: 693,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: "PHI PHI ISLAND",
            cn: "皮皮岛",
            ru: "Архипелаг Пхи-Пхи (Koh Phi Phi)",
          },
          textAnchor: "start",
          render: renderPinBubble,
        },
      },
      {
        type: "Pin",
        color: "#728dae",
        group: "island",
        animated: false,
        x: 286,
        y: 678,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: "LON ISLAND",
            cn: "桃花岛",
            ru: "Ко Лон (Koh Lon)",
          },
          textAnchor: "start",
          render: renderPinBubble,
        },
      },
      {
        type: "Pin",
        color: "#728dae",
        group: "island",
        animated: false,
        x: 312,
        y: 717,
        markerWidth: 10,
        bubble: {
          x: -10,
          y: -6,
          width: 76,
          text: {
            en: "MAITON ISLAND",
            cn: "蜜月岛",
            ru: "Остров Maiton Island",
          },
          textAnchor: "end",
          render: renderPinBubble,
        },
      },
      {
        type: "Pin",
        color: "#728dae",
        group: "island",
        animated: false,
        x: 283,
        y: 740,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: "CORAL ISLAND",
            cn: "珊瑚岛",
            ru: "Ко Хай (Koh Hae)",
          },
          textAnchor: "start",
          render: renderPinBubble,
        },
      },

      // School
      {
        type: "Pin",
        color: "#5b3a70",
        group: "school",
        animated: false,
        x: 250,
        y: 424,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -24,
          text: {
            en: ["PHUKET", "INTERNATIONAL", "ACADEMY"],
            cn: ["普吉国际学校"],
            ru: ["Пхукетская международная академия "],
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#5b3a70" },
        },
      },
      {
        type: "Pin",
        color: "#5b3a70",
        group: "school",
        animated: false,
        x: 240,
        y: 511,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -24,
          text: {
            en: ["BRITISH", "INTERNATIONAL", "SCHOOL"],
            cn: ["英国国际学校"],
            ru: ["Британская международная школа"],
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#5b3a70" },
        },
      },
      {
        type: "Pin",
        color: "#5b3a70",
        group: "school",
        animated: false,
        x: 252,
        y: 567,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -24,
          text: {
            en: ["HEADSTART", "INTERNATIONAL", "SCHOOL"],
            cn: ["普吉领袖国际学校", "", ""],
            ru: ["Междунарожная школа", "«Headstart»", ""],
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#5b3a70" },
        },
      },

      // Tourist Attraction
      {
        type: "Pin",
        color: "#4d6c64",
        group: "attraction",
        animated: false,
        x: 300,
        y: 376,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: ["BANGPAE", "WATERFALL"],
            cn: ["BANGPAE", "瀑布"],
            ru: ["Водопад ", "BANGPAE"],
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#4d6c64" },
        },
      },
      {
        type: "Pin",
        color: "#4d6c64",
        group: "attraction",
        animated: false,
        x: 270,
        y: 408,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: ["TONSAI", "WATERFALL"],
            cn: ["通赛瀑布", ""],
            ru: ["Водопад ", "TONSAI"],
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#4d6c64" },
        },
      },
      {
        type: "Pin",
        color: "#4d6c64",
        group: "attraction",
        animated: false,
        x: 253,
        y: 535,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: "CENTRAL FESTIVAL",
            cn: "普吉岛中央百货",
            ru: "ТРЦ «Сentral Festival»",
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#4d6c64" },
        },
      },
      {
        type: "Pin",
        color: "#4d6c64",
        group: "attraction",
        animated: false,
        x: 272,
        y: 552,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -18,
          text: {
            en: ["PHUKET", "OLDTOWN"],
            cn: ["普吉老镇", ""],
            ru: ["Старинный город", "«Phuket Town»"],
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#4d6c64" },
        },
      },
      {
        type: "Pin",
        color: "#4d6c64",
        group: "attraction",
        animated: false,
        x: 241,
        y: 586,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: "CHALONG TEMPLE",
            cn: "查龙寺",
            ru: "Храм CHALONG",
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#4d6c64" },
        },
      },
      {
        type: "Pin",
        color: "#4d6c64",
        group: "attraction",
        animated: false,
        x: 201,
        y: 620,
        markerWidth: 10,
        bubble: {
          x: -10,
          y: -6,
          width: 76,
          text: {
            en: "BIG BUDDHA",
            cn: "普吉大佛",
            ru: "Храм BIG BUDDHA",
          },
          textAnchor: "end",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#4d6c64" },
        },
      },
      {
        type: "Pin",
        color: "#4d6c64",
        group: "attraction",
        animated: false,
        x: 194,
        y: 697,
        markerWidth: 10,
        bubble: {
          x: 10,
          y: -6,
          text: {
            en: ["PHOMTHEP", "CAPE"],
            cn: ["神仙半岛", ""],
            ru: ["Мыс", "PHOMTHEP"],
          },
          textAnchor: "start",
          render: renderPinBubble,
          style: { fontSize: 10, fill: "#4d6c64" },
        },
      },
    ],
  };

  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  reset = () => {
    this.setState(INITIAL_STATE);
  };

  handleChangePage = (page) => this.setState({ currentPage: page });

  renderTexts = () => {
    const { currentLanguage } = this.props;
    const selActiveLanguage = switchLanguage(currentLanguage);
    const mergedTexts = _.merge(_.cloneDeep(texts), selActiveLanguage, {
      arrayMerge: overwriteMerge,
    });
    return mergedTexts.map((element, i) => (
      <MultiLineText key={`ele-${i}`} {...element} />
    ));
  };

  render() {
    const { texts, pins, t, currentLanguage } = this.props;
    const { currentPage } = this.state;

    return (
      <div className="city-map-container">
        <div className="page-menu">
          <ButtonGroup
            value={this.state.currentPage}
            items={[
              { value: "airport", label: t("Airport"), icon: iconAirport },
              { value: "beach", label: t("Beaches"), icon: iconBeach },
              { value: "island", label: t("Islands"), icon: iconIsland },
              { value: "school", label: t("Schools"), icon: iconSchool },
              {
                value: "attraction",
                label: t("Tourist Attrachtions"),
                icon: iconAttraction,
              },
            ]}
            direction="vertical"
            onChange={this.handleChangePage}
            renderItem={renderButton}
          />
        </div>
        <svg
          className="city-map phuket-map "
          viewBox="0 0 541 850"
          width="541"
          height="850"
        >
          <rect x={0} y={0} width={541} height={850} fill="#EDEDEF" />
          <image xlinkHref={bg} width={541} height={850} />
          <AnimatedBubble>
            <LagunaPropertyBubble
              x={178 - 62}
              y={387 - 62}
              width={62}
              height={62}
            />
          </AnimatedBubble>
          <g>
            {this.renderTexts()}
            <polygon
              id="arrow-thep"
              fill="#434A69"
              points="255.9,332.9 255.9,340 251.6,336.6 	"
            />
            <polygon
              id="arrow-bandon"
              fill="#434A69"
              points="213.6,427 213.6,419.9 217.9,423.2 	"
            />
            <polygon
              id="arrow-srisoon"
              fill="#434A69"
              points="188.2,473.7 188.2,480.8 183.8,477.4 	"
            />
          </g>
          <Mobile>
            <g id="pins" className="pins-mobile">
              {pins.map((pin, i) => (
                <Pin
                  key={`pin-${i}`}
                  {...pin}
                  currentLanguage={currentLanguage}
                  visible={pin.group !== "school"}
                />
              ))}
            </g>
          </Mobile>
          <Desktop>
            <g id="pins" className="pins-desktop">
              {pins.map((pin, i) => (
                <Pin
                  key={`pin-${i}`}
                  {...pin}
                  currentLanguage={currentLanguage}
                  visible={pin.group === currentPage}
                />
              ))}
            </g>
          </Desktop>
          {/* {currentPage === 'airport' && <Airplane x={225} y={253} width={20} height={21} />} */}
        </svg>
      </div>
    );
  }
}

export default PhuketMap;



// WEBPACK FOOTER //
// ./src/containers/PhuketMap/PhuketMap.js